


// import React from "react";
// import "./BookingForm.css";

// const BookingForm = () => {
//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const f = e.target;

//     const message = `New Booking Inquiry
// Name: ${f.name.value}
// Phone: ${f.phone.value}
// Vehicle: ${f.vehicle.value}
// Destination: ${f.end.value}
// Journey Date: ${f.journeyDate.value}`;

//     window.open(
//       `https://wa.me/919819399797?text=${encodeURIComponent(message)}`,
//       "_blank"
//     );
//   };

//   return (
//     <section className="booking-section">
//       <div className="booking-container">
//         <h4 className="booking-subtitle">ONLINE BOOKING</h4>
//         <h1 className="booking-title">Confirm your booking now!</h1>

//         <form className="booking-form" onSubmit={handleSubmit}>
//           <div>
//             <label>Your Name</label>
//             <input className="booking-input" name="name" required />
//           </div>

//           <div>
//             <label>Phone</label>
//             <input className="booking-input" name="phone" required />
//           </div>

//           <div className="hide-mobile">
//             <label>Number of Passenger</label>
//             <input className="booking-input" name="passenger" />
//           </div>

//           <div>
//             <label>Type of Vehicle</label>
//             <select className="booking-input" name="vehicle" required>
//               <option value="">Select Type of Vehicle</option>
//               <option>Sedan</option>
//               <option>Swift Dzire</option>
//               <option>Innova Crysta</option>
//               <option>Ertiga</option>
//               <option>Kia Carens</option>
//               <option>Urbania</option>
//             </select>
//           </div>

//           <div>
//             <label>End Destination</label>
//             <input className="booking-input" name="end" required />
//           </div>

//           <div>
//             <label>Journey Date</label>
//             <input type="date" className="booking-input" name="journeyDate" required />
//           </div>

//           <div className="hide-mobile">
//             <label>Return Date</label>
//             <input type="date" className="booking-input" name="returnDate" />
//           </div>

//           <div className="booking-btn-wrap">
//             <button className="booking-btn">Book via WhatsApp</button>
//           </div>
//         </form>
//       </div>
//     </section>
//   );
// };

// export default BookingForm;








import React from "react";
import "./BookingForm.css";

const BookingForm = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    const f = e.target;

    const message = `New Booking Inquiry
Name: ${f.name.value}
Phone: ${f.phone.value}
Number of Passengers: ${f.passenger.value}
Pickup Point: ${f.pickup.value}
Destination: ${f.end.value}
Vehicle: ${f.vehicle.value}
Journey Date: ${f.journeyDate.value}
Return Date: ${f.returnDate.value || "N/A"}`;

    window.open(
      `https://wa.me/919819399797?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <section className="booking-section">
      <div className="booking-container">
        <h4 className="booking-subtitle">ONLINE BOOKING</h4>
        <h1 className="booking-title">Confirm your booking now!</h1>

        <form className="booking-form" onSubmit={handleSubmit}>
          <div>
            <label>Your Name</label>
            <input
              className="booking-input"
              name="name"
              required
            />
          </div>

          <div>
            <label>Phone</label>
            <input
              className="booking-input"
              name="phone"
              required
            />
          </div>

          <div className="hide-mobile">
            <label>Number of Passenger</label>
            <input
              className="booking-input"
              name="passenger"
            />
          </div>

          {/* ✅ Pickup Point */}
          <div>
            <label>Pickup Point</label>
            <input
  className="booking-input"
  name="pickup"
  placeholder="Enter pickup location"
  required
/>

          </div>

          <div>
            <label>Type of Vehicle</label>
            <select
              className="booking-input"
              name="vehicle"
              required
            >
              <option value="">Select Type of Vehicle</option>
              <option>Sedan</option>
              <option>Swift Dzire</option>
              <option>Innova Crysta</option>
              <option>Ertiga</option>
              <option>Kia Carens</option>
              <option>Urbania</option>
            </select>
          </div>

          <div>
            <label>End Destination</label>
            <input
              className="booking-input"
              name="end"
              required
            />
          </div>

          <div>
            <label>Journey Date</label>
            <input
              type="date"
              className="booking-input"
              name="journeyDate"
              required
            />
          </div>

          <div className="hide-mobile">
            <label>Return Date</label>
            <input
              type="date"
              className="booking-input"
              name="returnDate"
            />
          </div>

          <div className="booking-btn-wrap">
            <button className="booking-btn" type="submit">
              Book via WhatsApp
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default BookingForm;
